import { t } from 'i18next';
import { useQueryClient } from 'react-query';
import { useBettieProfileUpdateStore } from '../store/useBettieProfileUpdateStore';
import { useUpdateBettieProfile } from '../../../domains/bettie/ui/hooks/useUpdateBettieProfile';
import { useSuccessPhotoCardToast } from '../../template/edit-collected-photo-cards/hooks/useSuccessPhotoCardToast';

interface UseChangeBettieNicknameProps {
  chatRoomId: string;
  onClose: () => void;
}

export const useChangeBettieNickname = ({ chatRoomId, onClose }: UseChangeBettieNicknameProps) => {
  const queryClient = useQueryClient();
  const { editedNickname, clear } = useBettieProfileUpdateStore();
  const { mutateAsync: updateBettieProfile, isLoading } = useUpdateBettieProfile();
  const showSuccessToast = useSuccessPhotoCardToast();

  const handleClose = () => {
    onClose();
    clear();
  };

  const handleUpdateProfile = async () => {
    const responseBody = {
      chat_room: {
        bettie_nickname: editedNickname
      }
    };
    try {
      const response = await updateBettieProfile({ body: responseBody, chatRoomId });
      if (response.chatRoom) {
        handleClose();
        queryClient.invalidateQueries(['ChatRoomMessages', chatRoomId]);
        queryClient.invalidateQueries(['chatRoom', chatRoomId]);
        showSuccessToast(
          'bottom',
          t('BettieChatRoom.profileUpdateDrawer.changeNicknameToast') as string
        );
      }
    } catch (error) {
      // biome-ignore lint/suspicious/noConsole: mutation failure should be visible during QA/debug
      console.error(error);
    }
  };

  return {
    handleUpdateProfile,
    isLoading,
    handleClose
  };
};
